<template>
  <div class="header">
    <div class="rowFluid">
      <div class="span2 col-md-12">
        <div  v-if="screenWidth >= 1650" class="logo">
          <a href="/" title="返回首页">
            <img :src="logoPic">
            <span class="logo_cntent">&nbsp;武汉港迪软件信息技术有限公司</span>
          </a>
        </div>
        <div v-else-if="screenWidth >= 1200" class="logos">
          <a href="/" title="返回首页">
            <img :src="logoPic">
            <span class="logo_cntent">&nbsp;武汉港迪软件信息技术有限公司</span>
          </a>
        </div>
        <div v-else class="logo">
          <a href="/" title="返回首页">
            <img :src="logoPic">
          </a>
        </div>
      </div>
      <div class="span8">
        <div class="mobileMenuBtn">
          <span class="span1"></span>
          <span class="span2"></span>
          <span class="span3"></span>
        </div>
        <div class="mobileMenuBtn_shad"></div>
        <div class="header_menu">
            <el-menu
             :default-active="this.$route.path"
              router
              class="el-menu-demo"
              mode="horizontal"
              background-color="#fff"
              text-color="#000"
              active-text-color="#409EFF">
        <template v-for="item in NavigateItem">
    <el-submenu v-if="item.items.length" :index="item.pid"  :key="item.pid" :class="screenWidth >= 1200? 'width':'widths'">
           <template slot="title" > {{ item.title }} </template>
            <el-menu-item v-for="(items, key) in item.items" :key="key" :index="items.path" > {{ items.title }}</el-menu-item>
    </el-submenu>
    <el-menu-item v-else :index="item.path" :key="item.key" :class="screenWidth >= 1200? 'width':'widths'">{{ item.title }}</el-menu-item>
  </template>
</el-menu>

        </div>
      </div>
      <div class="span2"></div>
    </div>
  </div>
</template>
<script>
import {GetMenuString} from '../../api/Menu'
export default {
  data () {
    return {
      screenWidth: 1920,
      NavigateItem: [],
      logoPic: require('../../assets/images/logo.png'),
      type: '/',
      bannerList: []
    }
  },
  mounted () {
    this.getMenu()
    this.screenWidth = document.body.clientWidth // 这样一刷新页面 依旧可以先获取获取此时的屏幕宽
    // header头部监听
    let that = this
    window.addEventListener('resize', function () {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    })
    // 若屏幕宽度变化 就实时派发
    this.$EventBus.$emit('screenWidth', {
      Width: that.screenWidth
    })
  },
  methods: {
    getMenu () {
      GetMenuString().then((resp) => {
        this.NavigateItem = JSON.parse(resp)
        //console.log(JSON.parse(resp))
      })
    }

  }
}
</script>
<style lang="less" rel="stylesheet/less" scoped>
.width
{
  width: 20%;
}
.widths
{
  width: 100%;
}
.el-menu-item
{
    font-size: 18px;
    color: #222527;
    font-weight: normal;
    line-height: 86px;
    text-align:center;
}

.el-menu-item:hover
{
  background-color: #fff !important;
}

/*is-active不起作用，因为element元素最外层还有样式
.el-menu-item:is-active
{
  border-bottom: 2px solid #409EFF;
  color: #409EFF;
}
*/
.el-menu.el-menu--horizontal {
     border-bottom: solid 0px #e6e6e6;
}

.el-menu--popup>.el-menu-item
{
font-size: 14px;
}

@import "../../assets/css/mixin.less";
</style>

<style lang="less" rel="stylesheet/less">
/*添加了scoped，则会导致el-submenu__title样式无法识别*/
.el-submenu__title
{
    font-size: 18px  !important;
    color: #222527;
    font-weight: normal;
    text-align:center;
}

.el-submenu__title:hover
{
  background-color: #fff !important;
}

.el-menu--horizontal>.el-submenu .el-submenu__title {
    line-height: 86px;
}

</style>



// WEBPACK FOOTER //
// src/components/TopBanner/TopBanner.vue